"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _MarkerMeaning = _interopRequireDefault(require("web/shared/telemetry/components/MarkerMeaning"));
var _MarkerRatesData = require("web/shared/telemetry/charts/MarkerRates.data.js");
var _MarkerRatesStyles = require("web/shared/telemetry/charts/MarkerRates.styles.js");
var _perfTablesStyles = require("web/shared/telemetry/perfTables.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The marker-rate table: one row per marker, with how often it fired and a
* bar showing that rate.
*
* Separate from the card that frames it so the table is the whole of what
* this file is about — the card supplies the heading and the prose, this
* supplies the numbers.
*/
function MarkerRatesTable(_ref) {
  let records = _ref.records,
    markerMeanings = _ref.markerMeanings;
  const rates = (0, _MarkerRatesData.buildMarkerRates)(records);
  if (rates.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
      children: "This metric records no marks."
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.tableWrap)), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.table)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.headCell, _perfTablesStyles.styles.dividedCell)), {}, {
            children: "marker"
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericHeadCell, _perfTablesStyles.styles.dividedCell)), {}, {
            children: "fired in"
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.headCell, _perfTablesStyles.styles.dividedCell)), {}, {
            children: "rate"
          }))]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
        children: rates.map(rate => /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.cell, _perfViewsStyles.styles.mono, _perfTablesStyles.styles.dividedCell)), {}, {
            children: [rate.marker, /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerMeaning.default, {
              marker: rate.marker,
              meanings: markerMeanings
            })]
          })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericCell, _perfTablesStyles.styles.dividedCell)), {}, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.mono)), {}, {
              children: rate.count
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.unit)), {}, {
              children: "/ ".concat(records.length)
            }))]
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.cell, _perfTablesStyles.styles.dividedCell)), {}, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_MarkerRatesStyles.styles.rateTrack)), {}, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_MarkerRatesStyles.styles.rateFill)), {}, {
                style: {
                  width: "".concat(rate.rate * 100, "%")
                }
              }))
            }))
          }))]
        }, rate.marker))
      })]
    }))
  }));
}
var _default = exports.default = MarkerRatesTable;